import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URL;
const presignedApiUrl = "https://et3vevc1mb.execute-api.us-east-1.amazonaws.com/v1/download?filename=projectData.json";

const initialProject = {
    projectList : [],
    isError : false,
    isloading : false,
    isSuccess : false,
    message :""
}


const getPresignedUrl = async () => {

    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: presignedApiUrl,
    
      };
      
      const getResponse  =  await axios.request(config)
      .then((response) => response)
      .catch((err) => console.log(err));

      
    return getResponse;
  
  };


  
export const getProjectList = createAsyncThunk("/projects" , async(thunkApi)=>{
    try {
        const pressignedurl = await getPresignedUrl();
        const data = await axios.get(pressignedurl.data);
        return data;
        
    } catch (error) {
        return thunkApi.rejectWithValue(error);
    }
})

const projectSlice = createSlice({
    name : "projectList",
    initialState:initialProject,
    reducers:{
    },
    extraReducers: (builder)=>{
        builder.addCase(getProjectList.pending,
        (state)=>{
            state.isloading = true;
        })
        .addCase(getProjectList.fulfilled,
        (state,action)=>{
            state.isSuccess = true;
            state.isloading = false;
            state.projectList = action.payload;
        })
        .addCase(getProjectList.rejected,
            (state,action)=>{
                state.isError = true;
                state.isloading = false;
                state.isSuccess = false;
                state.message = action.error;
            }
            )
    }
})

export default projectSlice.reducer;